import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './DialogRow.scss';

function DialogRow({ className, label, children }) {
  return (
    <div className={cn('rx-flex-row-container dialog-row', className)}>
      <div className="dialog-row__description">{label}</div>
      <div className="dialog-row__form">{children}</div>
    </div>
  );
}

DialogRow.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
};

export default DialogRow;
